import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-menu",
  "use": "icon-icon-menu-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-menu\">\n<g id=\"icon-icon-menu_&#231;&#188;&#150;&#231;&#187;&#132;\">\n<rect id=\"icon-icon-menu_Rectangle 3816\" x=\"5\" y=\"8\" width=\"22\" height=\"2\" fill=\"white\" />\n<rect id=\"icon-icon-menu_Rectangle 3817\" x=\"5\" y=\"15\" width=\"22\" height=\"2\" fill=\"white\" />\n<rect id=\"icon-icon-menu_Rectangle 3818\" x=\"5\" y=\"22\" width=\"22\" height=\"2\" fill=\"white\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol